/**
 * This will transform a string to kebab-case
 */
const toKebabCase = (str = '') => {
    /**
     * Make sure to seperate letters and numbers correctly
     * Also keep special accent characters
     */
    const match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-zÀ-ÖØ-öø-ÿ]+[0-9]*|[A-Z]|[0-9]+/g);
    if (!match)
        return '';
    return match.join('-').toLowerCase();
};
export default toKebabCase;
